
export default ({ app }, inject) => {
    const redirectFromApplicationResponse = (response) => {
        app.router.push({
            path: `/ansokan/${response.link}/`
        });
    };
    inject('redirectFromApplicationResponse', redirectFromApplicationResponse);
};